<template>
  <div>
    <myheader></myheader>
    <van-grid :border="false" :column-num="2">
      <template v-for="(item, key) in list">
        <van-grid-item :key="key">
          <van-image v-if="item.images.length > 0" :src="item.images[0]['url']" />
          <van-cell :to="'products/' + item.id">
            <div style="text-align: center; font-weight: bold;">SALE</div>
            <div style="text-align: center;">
              {{item.title}}
            </div>
            <div style="text-align: center;">
              From ${{item.price}}
            </div>
          </van-cell>
        </van-grid-item>
      </template>
    </van-grid>
  </div>
</template>

<script>
  import { Field, Button, Cell, CellGroup, Toast, Swipe, SwipeItem, Image, Row, Col, Grid, GridItem } from 'vant'
  import {getList} from '@/api/product'
  export default {
    components: {
      [Field.name]: Field,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Image.name]: Image,
      [Row.name]: Row,
      [Col.name]: Col,
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Button.name]: Button,
    },
    name: "list",
    data() {
      return {
        list: []
      }
    },
    mounted() {
      getList().then(res => {
        console.log(res)
        this.list = res.data
        console.log(this.list)
      })
    }
  }
</script>

<style scoped>

</style>
